import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class UnsoldLotModel extends BaseModel {
  paddle_number = null
  highest_bid_amount = null

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {};

  attributeHints = {};

  attributeLabels = {
    paddle_number: i18n.t('Bidder'),
    highest_bid_amount: i18n.t('Highest Bid Amount')
  };
}
